export default ['container', 'document', 'media', 'supports'];
